//Form Validation for submission
const Validator = require("validator");
const isEmpty = require("../../common/functions/is-empty");

export function validateSupplierNameInput(data) {
  let validationErrors = {};
  console.log({ data });
  data.supplierName = !isEmpty(data.supplierName) ? data.supplierName : "";
  data.supplierNumber = !isEmpty(data.supplierNumber)
    ? data.supplierNumber
    : null;

  if (isNaN(data.supplierNumber)) {
    validationErrors.supplierNumber =
      "Supplier Number field should be a number";
  }
  //check if fields are empty
  if (Validator.isEmpty(data.supplierName)) {
    validationErrors.supplierName = "Supplier Name field is required";
  }
  if (!data.supplierNumber) {
    validationErrors.supplierNumber = "Supplier Number field is required";
  }

  return {
    validationErrors,
    isValid: isEmpty(validationErrors),
  };
}
